<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Уведомления сотрудника</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <p>
            В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Сотрудники&raquo;. В&nbsp;списке сотрудников выберите
            нужного и&nbsp;нажмите справа на&nbsp;иконку карандаша для перехода в&nbsp;редактирование.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-sotrudnika-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="uvedomleniya-sotrudnika"
            class="typography__headline2"
          >
            Уведомления сотрудника
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>На&nbsp;открывшейся странице редактирования сотрудника пролистайте в&nbsp;самый низ.</p>

            <p>
              Уведомления будут поступать на&nbsp;электронную почту, указанную в&nbsp;основной информации. Если
              вы&nbsp;её&nbsp;там не&nbsp;заполняли, но&nbsp;хотите чтобы уведомления приходили&nbsp;&mdash; самое время
              подняться выше и&nbsp;добавить.
            </p>

            <p>
              Активность уведомлений по-умолчанию включена для всех видов. Проверьте, возможно понадобится что-то
              изменить.
            </p>

            <p>
              Как настроите уведомления, нажмите &laquo;Сохранить&raquo; в&nbsp;самом низу страницы. После успешного
              сохранения увидите в&nbsp;правом верхнем углу уведомление.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-sotrudnika-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Сотрудники",
    url: "/faq/categories/sotrudniki",
  },
  {
    name: "Уведомления сотрудника",
  },
];

const menu = [
  {
    name: "Как попасть",
    url: "kak-popast",
  },
  {
    name: "Уведомления сотрудника",
    url: "uvedomleniya-sotrudnika",
  },
];

const relatedArticles = [
  {
    name: "Добавление и&nbsp;редактирование сотрудника",
    slug: "dobavleniye-i-redaktirovaniye-sotrudnika",
  },
  {
    name: "Список сотрудников и&nbsp;их данные",
    slug: "spisok-sotrudnikov-i-ikh-dannye",
  },
  {
    name: "Расписание сотрудника",
    slug: "raspisaniye-raboty",
  },
];

useSeoMeta({
  title: "Уведомления сотрудника",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
